/**
 * TODO: This is the newer BaseComponent. Need to refactor others. - Nov 1, 2018
 */
export default class BaseComponentV2 {

  /**
   * @param element jQuery element.
   */
  constructor(element) {

    /**
     * jQuery element.
     */
    this.element = element;
  }

  /**
   * Attach a DOM element to this component.
   *
   * @param element jQuery element.
   */
  setElement(element) {

    this.element = element;
  }

  /**
   * Returns data from the provided key.
   *
   * @param key
   * @return {*}
   */
  getData(key) {

    return this.element.data(key);
  }

  setDefaultData(data) {

    for (let key in data) {
      const val = this.getData(key);

      if (val === null || val === undefined) {
        this.element.data(key, data[key]);
      }
    }
  }

  render(html) {

    this.element.html(html);
  }
}
